import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChampSourceProduitCrm } from 'src/app/parametrage/core/model/produitCrm/ChampSourceProduitCrm';
import { ProduitCrmService } from 'src/app/parametrage/core/service/produit-crm.service';

@Component({
  selector: "app-add-champ-produit-crm",
  templateUrl: "./add-champ-produit-crm.component.html",
  styleUrls: ["./add-champ-produit-crm.component.scss"]
})
export class AddChampProduitCrmComponent implements OnInit {
  champSourceProduitCrm: ChampSourceProduitCrm;
  form: FormGroup;
  pressButton: Boolean = false;
  title: string;
  loading = false;
  submitted = false;
  errorMessage: string;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _produitCrmService: ProduitCrmService
  ) {}

  ngOnInit() {
    this.form = this.createForm(this.champSourceProduitCrm);
  }

  createForm(data: ChampSourceProduitCrm) {
    if (data) {
      return this.fb.group({
        id: [data ? data.id : ""],
        codeChamp: [
          data ? data.codeChamp : "",
          Validators.compose([Validators.required])
        ],
        libelleChamp: [data ? data.libelleChamp : ""],
        typeChamp: [data ? data.typeChamp : null]
      });
    } else {
      return this.fb.group({
        id: [data ? data.id : ""],
        codeChamp: ["", Validators.compose([Validators.required])],
        libelleChamp: ["", Validators.compose([Validators.required])],
        typeChamp: ["", Validators.compose([Validators.required])]
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    this.findInvalidControls();
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    if (!this.champSourceProduitCrm) {
      this.createData();
    } else {
      this.updateData();
    }
  }

  createData() {
    this._produitCrmService.addChampSourceProduitCrm(this.form.value).subscribe(
      data => {
        this.activeModal.close();
      },
      error => {
        if (error && error.error && error.status == 409) {
          this.errorMessage = error.error.message;
        }
      }
    );
  }

  updateData() {
    this._produitCrmService
      .updateChampSourceProduitCrm(this.champSourceProduitCrm.id, this.form.value)
      .subscribe(
        data => {
          this.activeModal.close();
        },
        error => {
          if (error && error.error && error.status == 409) {
            this.errorMessage = error.error.message;
          }
        }
      );
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log(invalid);
  }
}
